//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import DeleteDialog from "@/modules/home/components/delete-dialog.vue";
import { i18n } from "@/i18n";
import { AdminPermissions } from "@/modules/admins/admins-permissions.js";
import { UserPermissions } from "@/modules/users/users-permissions.js";
import { mapGetters } from "vuex";
export default {
  name: "app-table",
  props: ["data", "columns", "user"],
  data() {
    return {
      language: "",
      deleteUser: false,
      pagination: {
        sortBy: "desc",
        descending: false,
        page: 1,
        rowsPerPage: this.$q.screen.width == 1024 ? 14 : 7,
      },
    };
  },
  components: {
    [DeleteDialog.name]: DeleteDialog,
  },
  computed: {
    ...mapGetters({
      currentUser: "auth/currentUser",
    }),
    hasPermissionToEditAdmin() {
      return new AdminPermissions(this.currentUser).edit;
    },
    hasPermissionToImportAdmin() {
      return new AdminPermissions(this.currentUser).import;
    },
    hasPermissionToDestroyAdmin() {
      return new AdminPermissions(this.currentUser).destroy;
    },
    hasPermissionToReadAdmin() {
      return new AdminPermissions(this.currentUser).read;
    },
    hasPermissionToDestroyUser() {
      // console.log('user permission',new JobPermissions(this.currentUser).destroy)
      return new UserPermissions(this.currentUser).destroy;
    },
    hasPermissionToReadUser() {
      return new UserPermissions(this.currentUser).read;
    },
    pagesNumber() {
      return Math.ceil(this.data.length / this.pagination.rowsPerPage);
    },
  },
  methods: {
    i18n(key, args) {
      return i18n(key, args);
    },
    close() {
      this.deleteUser = false;
    },
    goToUser(id) {
      if (this.user == "user") this.$router.push(`/users/${id}`);
      if (this.user == "admin") this.$router.push(`/admins/${id}`);
    },
    formatMembershipDate(dateInput) {
      if (!dateInput) return "";

      try {
        let date;

        // Handle Firebase Timestamp objects
        if (dateInput && typeof dateInput === "object" && dateInput.seconds) {
          date = new Date(dateInput.seconds * 1000);
        } else if (typeof dateInput === "string") {
          date = new Date(dateInput);
        } else {
          date = new Date(dateInput);
        }

        const options = {
          year: "numeric",
          month: "long",
          day: "numeric",
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
          timeZoneName: "short",
        };

        return date.toLocaleDateString(
          this.language === "ar" ? "ar-EG" : "en-US",
          options
        );
      } catch (error) {
        return dateInput; // Return original if parsing fails
      }
    },
    isExpired(dateInput) {
      if (!dateInput) return true; // Treat missing date as expired

      try {
        let expirationDate;

        // Handle Firebase Timestamp objects
        if (dateInput && typeof dateInput === "object" && dateInput.seconds) {
          expirationDate = new Date(dateInput.seconds * 1000);
        } else if (typeof dateInput === "string") {
          expirationDate = new Date(dateInput);
        } else {
          expirationDate = new Date(dateInput);
        }

        const currentDate = new Date();
        return expirationDate < currentDate;
      } catch (error) {
        return true; // Treat invalid dates as expired
      }
    },
    getSubscriptionCardClass(subscription) {
      if (!subscription) return "bg-grey-2 text-grey-8";

      switch (subscription.toLowerCase()) {
        case "premium":
          return "bg-purple-2 text-purple-8";
        case "basic":
          return "bg-blue-2 text-blue-8";
        case "free":
          return "bg-grey-2 text-grey-8";
        default:
          return "bg-teal-2 text-teal-8";
      }
    },
  },
  mounted() {
    this.language = localStorage.getItem("language");
  },
};
